import * as React from 'react';

const Heart = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={28} height={29} fill="none" viewBox="0 0 28 29" {...props}>
        <path
            fill="currentColor"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth={1.5}
            d="M23.105 7.77a5.665 5.665 0 0 0-8.015 0l-1.092 1.092-1.092-1.092a5.668 5.668 0 0 0-8.015 8.014l1.092 1.092 8.015 8.015 8.015-8.014 1.092-1.092a5.664 5.664 0 0 0 0-8.015Z"
        />
    </svg>
);
export default Heart;
